import type { Customer } from "@/api/types";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn, getCustomerAvatarSrc, getCustomerName, getInitials } from "@/lib/utils";

type CustomerAvatarProps = {
  customer: Partial<Customer> | undefined | null;
  className?: string;
  /** Restyle the initials fallback, e.g. for dark surfaces (call UI). */
  fallbackClassName?: string;
};

export function CustomerAvatar({ customer, className, fallbackClassName }: CustomerAvatarProps) {
  const name =
    customer?.firstName || customer?.lastName ? getCustomerName(customer as Customer) : null;
  const initials = name ? getInitials(name) : null;

  return (
    <Avatar className={cn("w-8 h-8 shrink-0 border text-xs", className)}>
      <AvatarImage src={getCustomerAvatarSrc(customer as Customer) || ""} />
      <AvatarFallback
        className={cn(
          "bg-gradient-to-b from-background to-muted/50",
          initials && "text-foreground font-medium",
          fallbackClassName,
        )}
      >
        {initials || (
          <svg viewBox="0 0 18 18" className="w-full h-full text-muted-foreground">
            <use href="/images/avatar.svg#icon" />
          </svg>
        )}
      </AvatarFallback>
    </Avatar>
  );
}
